import styled from "styled-components";
import { Box as BoxUI } from "@mui/material";

export const Box = styled(BoxUI)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 464px;
  max-width: calc(100vw - 32px);
  padding: 32px 24px;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  text-align: left;
  font-family: "Gotham", sans-serif;
`;

export const ContentActions = styled.div`
  font-family: "Gotham", sans-serif;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 24px;

  & button {
    font-family: "Gotham", sans-serif;
  }
`;

export const ModalTitle = styled.span`
  font-family: "Gotham", sans-serif;
  font-size: 22px;
  line-height: 28px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.primary};
  display: block;
  margin-bottom: 16px;
`;

export const ModalBody = styled.span`
  font-family: "Gotham", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.secondary};
  display: block;
  white-space: pre-line;
`;
